import script from "./service-fee-invoice.vue?vue&type=script&lang=ts&setup=true"
export * from "./service-fee-invoice.vue?vue&type=script&lang=ts&setup=true"

import "./service-fee-invoice.vue?vue&type=style&index=0&id=d86743f8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d86743f8"]])

export default __exports__